WiseMetering.Collection.IntegrationLicenseLogs = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.IntegrationLicenseLogs,
    url: '/integration_license_logs'
});

